import React from 'react';
import { i18n } from 'config/locales';
import SvgComponent from 'components/Form/SvgComponent';

const KickbackBanner = () => (
  <div className="usa-alert usa-alert-warning kickback-banner">
    <div className="usa-alert-body kickback-banner__wrapper">
      <div className="triangle-exclamation" aria-hidden="true">
        <SvgComponent className="triangle-exclamation" src="/img/triangle-exclamation.svg" />
      </div>
      <p className="usa-alert-text kickback-banner__text">{i18n.t('review.kickbackMessage')}</p>
    </div>
  </div>
);

export default KickbackBanner;
